
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/mediaelement/jst/UploadMediaTrackForm';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <p class=\"alert alert-info\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': ("<strong>$1</strong>"),
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.upload_media_track_info", "*Instructions:* Follow these three steps to create a subtitle file for your video, then upload it here. If you already have an SRT subtitle file you can skip to step 3.", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.upload_media_track_info", "*Instructions:* Follow these three steps to create a subtitle file for your video, then upload it here. If you already have an SRT subtitle file you can skip to step 3.", options)))
    + "\n    </p>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <div>\n        <p class=\"uploadMediaTrackFormDescription\">\n        <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.upload_media_track_form_step1_label", "Step 1:", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.upload_media_track_form_step1_label", "Step 1:", options)))
    + "</strong>\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.upload_media_track_form_description_1", "Copy this video URL:", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.upload_media_track_form_description_1", "Copy this video URL:", options)))
    + "\n        </p>\n        <div id=\"media-track-video-url-container\"></div>\n      </div>\n\n      <div>\n        <p class=\"uploadMediaTrackFormDescription\">\n        <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.upload_media_track_form_step2_label", "Step 2:", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.upload_media_track_form_step2_label", "Step 2:", options)))
    + "</strong>\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.upload_media_track_form_description_2", "Create a subtitle file by clicking the following link:", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.upload_media_track_form_description_2", "Create a subtitle file by clicking the following link:", options)))
    + "\n          <a href=\"https://amara.org/en/videos/create/\" target=\"_blank\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.amara_link_text", "Amara (Subtitle creation tool)", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.amara_link_text", "Amara (Subtitle creation tool)", options)))
    + "</a>.\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.amara_instructions", "When prompted, paste in the video URL copied in step 1.", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.amara_instructions", "When prompted, paste in the video URL copied in step 1.", options)))
    + "\n        </p>\n      </div>\n    ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.upload_media_track_form_step3_label", "Step 3:", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.upload_media_track_form_step3_label", "Step 3:", options)))
    + "</strong>\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': ("<a target=\"_blank\" href=\"http://dev.w3.org/html5/webvtt/\">$1</a>"),
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.upload_media_track_form_description", "Once you have a subtitle track in either the SRT or *WebVTT* format, you can upload it here.", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.upload_media_track_form_description", "Once you have a subtitle track in either the SRT or *WebVTT* format, you can upload it here.", options)))
    + "\n        ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': ("<a target=\"_blank\" href=\"http://dev.w3.org/html5/webvtt/\">$1</a>"),
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.upload_media_track_form_description_3", "Upload a subtitle track in either the SRT or *WebVTT* format.", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.upload_media_track_form_description_3", "Upload a subtitle track in either the SRT or *WebVTT* format.", options)))
    + "\n        ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n                <option value=\"";
  if (helper = helpers.code) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.code); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">";
  if (helper = helpers.name) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.name); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "</option>\n              ";
  return buffer;
  }

  buffer += "<div title=\"Create/Add Subtitles\" class=\"uploadMediaTrackForm bootstrap-form form-horizontal\">\n  \n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.is_amazon_url), {hash:{},inverse:self.noop,fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  <div class=\"content-box border border-trbl border-round pad-box\">\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.is_amazon_url), {hash:{},inverse:self.noop,fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n    <div>\n\n      <p class=\"uploadMediaTrackFormDescription\">\n        ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.is_amazon_url), {hash:{},inverse:self.program(7, program7, data),fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </p>\n\n      <div class=\"content-box media-track-content-box\">\n        <div class=\"invalidInputMsg alert alert-error\" style=\"display:none;\">\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'w0': ("<strong>$1</strong>"),
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.error_message", "*Error:* You must choose a language and a valid track file.", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.error_message", "*Error:* You must choose a language and a valid track file.", options)))
    + "\n        </div>\n\n        <div class=\"control-group\">\n          <label class=\"control-label\" for=\"umtf_locale\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.language", "Language", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.language", "Language", options)))
    + "</label>\n          <div class=\"controls\">\n            <select name=\"locale\" id=\"umtf_locale\">\n              <option value=''>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.choose_a_language", "--Choose a Language--", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.choose_a_language", "--Choose a Language--", options)))
    + "</option>\n              ";
  stack1 = helpers.each.call(depth0, (depth0 && depth0.languages), {hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n            </select>\n          </div>\n        </div><!-- control group end -->\n\n        <div class=\"control-group\">\n          <label class=\"control-label\" for=\"umtf_content\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("widget.upload_media_track_form")
  },data:data},helper ? helper.call(depth0, "widget.upload_media_track_form.file", "File", options) : helperMissing.call(depth0, "t", "widget.upload_media_track_form.file", "File", options)))
    + "</label>\n          <div class=\"controls\">\n            <input class=\"input-file\" id=\"umtf_content\" name=\"content\" type=\"file\">\n          </div>\n        </div><!-- control group end -->\n      </div><!-- content-box end -->\n    </div><!-- media track step -->\n   </div><!-- end border border-tbl -->\n</div>\n";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: 'f2',
      bundle: 'jst/widget/UploadMediaTrackForm'
    });
  ;
    export default templates[name];
  